// extracted by mini-css-extract-plugin
module.exports = {"button":"ButtonOutboundLink-module--button--3D1PO"};